import {
  Component,
  inject,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { BrandService } from 'app/core/services/brand.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoComponent {
  private readonly brandService = inject(BrandService);
  brandConfig = this.brandService.config;

  collapsed = input(false);
}
